module.exports = __webpack_public_path__ + "8cc463f58215bd3fe1b0411252e4d81a.pdf";